import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';

import Styles from './style.module.scss';
import { Tooltip } from '../../../../../../../Tooltip';
import withComponentName from '../../../../../../../../decorators/withComponentName';

const cx = classNames.bind(Styles);

export const PricingPlansTableBody = (props) => {
  const {
    activePlanTab, tableContent, width, scrollToForm,
  } = props;

  const tooltip = {
    commercial: (
      <Tooltip
        className={cx('question__help')}
        isBigScreen={width >= 2800}
      >
        Data and its derivatives may be used to generate revenue.&nbsp;
        <a
          href="https://help.cityfalcon.com/hc/en-us/articles/360033692854-non-commercial-use"
          rel="noreferrer"
          target="_blank"
        >
          Learn more
        </a>
        &nbsp;about commercial and non-commercial use.
      </Tooltip>
    ),
    noncommercial: (
      <Tooltip
        className={cx('question__help')}
        isBigScreen={width >= 2800}
      >
        This plan cannot be used to generate revenue directly or indirectly.
        {' '}
        <a
          href="https://help.cityfalcon.com/hc/en-us/articles/360033692854-non-commercial-use"
          rel="noreferrer"
          target="_blank"
        >
          See details.
        </a>
      </Tooltip>
    ),
  };

  return (
    <tbody className={cx('tableBody')}>
      {
        tableContent.map((content) => (
          <tr key={content.id} className={cx(content.className)}>
            {((activePlanTab === 'commercial'
              && content.commercial
              && !content.noncommercial)
              || (content.commercial && content.noncommercial))
              && (
                <th className={cx(content.className)}>
                  <div className={cx('cell__title')}>
                    <div className={cx('title__content')}>
                      {content.title}
                    </div>
                    <div className={cx('title__question_help', {
                      'key-headlines': content.title === 'Key Headlines,',
                      'insider-transaction': content.title === 'Insider Transactions',
                    })}
                    >
                      {content.withQuestionMark && (
                        tooltip[activePlanTab] ?? tooltip.noncommercial
                      )}
                      {content.textQuestionMark && (
                        <Tooltip
                          className={cx('question__help')}
                          tooltipClassName={content.classname}
                          isBigScreen={width >= 2800}
                        >
                          {content.textQuestionMark}
                          {content.linkQuestionMark && (
                            <>
                              {' '}
                              <a href={content.linkQuestionMark} rel="noreferrer" target="_blank">Learn more.</a>
                            </>
                          )}
                        </Tooltip>
                      )}
                    </div>
                  </div>
                </th>
              )}

            {
              activePlanTab === 'commercial'
                ? (
                  content.commercial
                  && (
                    <>
                      {content.commercial.businessStarter && (
                        <td
                          colSpan={content.commercial.businessStarter.colSpan
                            && content.commercial.businessStarter.colSpan}
                          rowSpan={content.commercial.rowSpan && content.commercial.rowSpan}
                          className={cx(content.commercial.className)}
                        >
                          {content.commercial.businessStarter.text === 'No'
                            && (
                              <span className={cx('No')}>
                                <FontAwesomeIcon icon={faXmark} />
                              </span>
                            )}
                          {content.commercial.businessStarter.text === 'Yes'
                            && (
                              <span className={cx('Yes')}>
                                <FontAwesomeIcon icon={faCheck} />
                              </span>
                            )}
                          {content.commercial.businessStarter.text !== 'Yes'
                            && content.commercial.businessStarter.text !== 'No'
                            && content.commercial.businessStarter.link
                            && (
                              <a href={content.commercial.businessStarter.link}>
                                {content.commercial.businessStarter.text}
                              </a>
                            )}
                          {content.commercial.businessStarter.text !== 'Yes'
                            && content.commercial.businessStarter.text !== 'No'
                            && !content.commercial.businessStarter.link
                            && content.commercial.businessStarter.text}
                          {content.commercial.businessStarter.withQuestionMark && (
                            tooltip[activePlanTab] ?? tooltip.noncommercial
                          )}
                          {content.commercial.businessStarter.textQuestionMark && (
                            <Tooltip
                              className={cx('question__help')}
                              tooltipClassName={content.commercial.businessStarter.classname}
                              isBigScreen={width >= 2800}
                            >
                              {content.commercial.businessStarter.textQuestionMark}
                              {' '}
                              {content.commercial.businessStarter.linkQuestionMark && (
                                <a
                                  href={content.commercial.businessStarter.linkQuestionMark}
                                  rel="noreferrer"
                                  target="_blank"
                                >
                                  Learn more.

                                </a>
                              )}
                            </Tooltip>
                          )}
                        </td>
                      )}
                      {content.commercial.starterPlus
                        && (
                          <td
                            colSpan={content.commercial.starterPlus.colSpan
                              && content.commercial.starterPlus.colSpan}
                            rowSpan={content.commercial.rowSpan && content.commercial.rowSpan}
                            className={cx(content.commercial.className)}
                          >
                            {content.commercial.starterPlus.text === 'No'
                              && (
                                <span className={cx('No')}>
                                  <FontAwesomeIcon icon={faXmark} />
                                </span>
                              )}
                            {content.commercial.starterPlus.text === 'Yes'
                              && (
                                <span className={cx('Yes')}>
                                  <FontAwesomeIcon icon={faCheck} />
                                </span>
                              )}
                            {(content.commercial.starterPlus.text !== 'Yes'
                              && content.commercial.starterPlus.text !== 'No')
                              && content.commercial.starterPlus.text}
                            {content.commercial.starterPlus.withQuestionMark && (
                              tooltip[activePlanTab] ?? tooltip.noncommercial
                            )}
                            {content.commercial.starterPlus.textQuestionMark && (
                              <Tooltip
                                className={cx('question__help')}
                                tooltipClassName={content.commercial.starterPlus.classname}
                                isBigScreen={width >= 2800}
                              >
                                {content.commercial.starterPlus.textQuestionMark}
                                {' '}
                                {content.commercial.starterPlus.linkQuestionMark && (
                                  <a
                                    href={content.commercial.starterPlus.linkQuestionMark}
                                    rel="noreferrer"
                                    target="_blank"
                                  >
                                    Learn more.
                                  </a>
                                )}
                              </Tooltip>
                            )}
                          </td>
                        )}

                      {content.commercial.scaleUp && (
                        <td
                          colSpan={content.commercial.scaleUp.colSpan
                            && content.commercial.scaleUp.colSpan}
                          rowSpan={content.commercial.scaleUp.rowSpan
                            && content.commercial.scaleUp.rowSpan}
                          className={cx(content.commercial.className)}
                        >
                          {content.commercial.scaleUp.text === 'No'
                            && (
                              <span className={cx('No')}>
                                <FontAwesomeIcon icon={faXmark} />
                              </span>
                            )}
                          {content.commercial.scaleUp.text === 'Yes'
                            && (
                              <span className={cx('Yes')}>
                                <FontAwesomeIcon icon={faCheck} />
                              </span>
                            )}
                          {(content.commercial.scaleUp.text !== 'Yes'
                            && content.commercial.scaleUp.text !== 'No')
                            && content.commercial.scaleUp.text}
                          {content.commercial.scaleUp.withQuestionMark && (
                            tooltip[activePlanTab] ?? tooltip.noncommercial
                          )}
                          {content.commercial.scaleUp.textQuestionMark && (
                            <Tooltip
                              className={cx('question__help')}
                              isBigScreen={width >= 2800}
                            >
                              {content.commercial.scaleUp.textQuestionMark}
                              {' '}
                              <a
                                href={content.commercial.scaleUp.linkQuestionMark}
                                rel="noreferrer"
                                target="_blank"
                              >
                                Learn more.

                              </a>
                            </Tooltip>
                          )}
                        </td>
                      )}

                      {content.commercial.premiumScaleUp && (
                        <td
                          colSpan={content.commercial.colSpan && content.commercial.colSpan}
                          rowSpan={content.commercial.rowSpan && content.commercial.rowSpan}
                          className={cx(content.commercial.className)}
                        >
                          {content.commercial.premiumScaleUp.text === 'No'
                            && (
                              <span className={cx('No')}>
                                <FontAwesomeIcon icon={faXmark} />
                              </span>
                            )}
                          {content.commercial.premiumScaleUp.text === 'Yes'
                            && (
                              <span className={cx('Yes')}>
                                <FontAwesomeIcon icon={faCheck} />
                              </span>
                            )}
                          {(content.commercial.premiumScaleUp.text !== 'Yes'
                            && content.commercial.premiumScaleUp.text !== 'No')
                            && content.commercial.premiumScaleUp.text}
                          {content.commercial.premiumScaleUp.withQuestionMark && (
                            tooltip[activePlanTab] ?? tooltip.noncommercial
                          )}
                          {content.commercial.premiumScaleUp.textQuestionMark && (
                            <Tooltip
                              className={cx('question__help')}
                              isBigScreen={width >= 2800}
                            >
                              {content.commercial.premiumScaleUp.textQuestionMark}
                              {' '}
                              <a
                                href={content.commercial.premiumScaleUp.linkQuestionMark}
                                rel="noreferrer"
                                target="_blank"
                              >
                                Learn more.
                              </a>
                            </Tooltip>
                          )}
                        </td>
                      )}

                      {content.commercial.enterprise && (
                        <td
                          colSpan={content.commercial.colSpan && content.commercial.colSpan}
                          rowSpan={content.commercial.rowSpan && content.commercial.rowSpan}
                          className={cx(content.commercial.className)}
                        >
                          {content.commercial.enterprise.text === 'No'
                            && (
                              <span className={cx('No')}>
                                <FontAwesomeIcon icon={faXmark} />
                              </span>
                            )}
                          {content.commercial.enterprise.text === 'Yes' && (
                            <span className={cx('Yes')}>
                              <FontAwesomeIcon icon={faCheck} />
                            </span>
                          )}
                          {(content.commercial.enterprise.text !== 'Yes'
                            && content.commercial.enterprise.text !== 'No')
                            && content.commercial.enterprise.text}
                          {content.commercial.enterprise.withQuestionMark && (
                            tooltip[activePlanTab] ?? tooltip.noncommercial
                          )}
                          {content.commercial.enterprise.textQuestionMark && (
                            <Tooltip
                              className={cx('question__help')}
                              isBigScreen={width >= 2800}
                            >
                              {content.commercial.enterprise.textQuestionMark}
                              {' '}
                              <a
                                href={content.commercial.enterprise.linkQuestionMark}
                                rel="noreferrer"
                                target="_blank"
                              >
                                Learn more.

                              </a>
                            </Tooltip>
                          )}
                        </td>
                      )}
                    </>
                  )

                ) : (
                  content.noncommercial
                  && (
                    <>
                      {content.noncommercial.personal_developer
                        && (
                          <td
                            colSpan={content.noncommercial.personal_developer.colSpan
                              && content.noncommercial.personal_developer.colSpan}
                            rowSpan={content.noncommercial.rowSpan
                              && content.noncommercial.rowSpan}
                            className={cx(content.noncommercial.className)}
                          >
                            {content.noncommercial.personal_developer.text === 'No' && (
                              <span className={cx('No')}>
                                <FontAwesomeIcon icon={faXmark} />
                              </span>
                            )}
                            {content.noncommercial.personal_developer.text === 'Yes' && (
                              <span className={cx('Yes')}>
                                <FontAwesomeIcon icon={faCheck} />
                              </span>
                            )}
                            {(content.noncommercial.personal_developer.text !== 'Yes'
                              && content.noncommercial.personal_developer.text !== 'No')
                              && content.noncommercial.personal_developer.link
                              && (
                                <Link to={content.noncommercial.personal_developer.link}>
                                  {content.noncommercial.personal_developer.text}
                                </Link>
                              )}
                            {(content.noncommercial.personal_developer.text !== 'Yes'
                              && content.noncommercial.personal_developer.text !== 'No')
                              && !content.noncommercial.personal_developer.link
                              && content.noncommercial.personal_developer.text}
                            {content.noncommercial.personal_developer.withQuestionMark && (
                              tooltip[activePlanTab] ?? tooltip.noncommercial
                            )}
                            {content.noncommercial.personal_developer.textQuestionMark && (
                              <Tooltip
                                className={cx('question__help')}
                                tooltipClassName={
                                  content.noncommercial.personal_developer.classname
                                }
                                isBigScreen={width >= 2800}
                              >
                                {content.noncommercial.personal_developer.textQuestionMark}
                                {' '}
                                {content.noncommercial.personal_developer.linkQuestionMark && (
                                  <a
                                    href={content.noncommercial.personal_developer.linkQuestionMark}
                                    rel="noreferrer"
                                    target="_blank"
                                  >
                                    Learn more.

                                  </a>
                                )}
                              </Tooltip>
                            )}
                          </td>
                        )}

                      {content.noncommercial.personalStarter
                        && (
                          <td
                            colSpan={content.noncommercial.colSpan
                              && content.noncommercial.colSpan}
                            rowSpan={content.noncommercial.rowSpan
                              && content.noncommercial.rowSpan}
                            className={cx(content.noncommercial.className)}
                          >
                            {content.noncommercial.personalStarter.text === 'No' && (
                              <span className={cx('No')}>
                                <FontAwesomeIcon icon={faXmark} />
                              </span>
                            )}
                            {content.noncommercial.personalStarter.text === 'Yes' && (
                              <span className={cx('Yes')}>
                                <FontAwesomeIcon icon={faCheck} />
                              </span>
                            )}
                            {(content.noncommercial.personalStarter.text !== 'Yes'
                              && content.noncommercial.personalStarter.text !== 'No')
                              && content.noncommercial.personalStarter.link
                              && (
                                <Link to={content.noncommercial.personalStarter.link}>
                                  {content.noncommercial.personalStarter.text}
                                </Link>
                              )}
                            {(content.noncommercial.personalStarter.text !== 'Yes'
                              && content.noncommercial.personalStarter.text !== 'No')
                              && !content.noncommercial.personalStarter.link
                              && content.noncommercial.personalStarter.text}
                            {content.noncommercial.personalStarter.withQuestionMark && (
                              tooltip[activePlanTab] ?? tooltip.noncommercial
                            )}
                            {content.noncommercial.personalStarter.textQuestionMark && (
                              <Tooltip
                                className={cx('question__help')}
                                tooltipClassName={content.noncommercial.personalStarter.classname}
                                isBigScreen={width >= 2800}
                              >
                                {content.noncommercial.personalStarter.textQuestionMark}
                                {' '}
                                {content.noncommercial.personalStarter.linkQuestionMark && (
                                  <a
                                    href={content.noncommercial.personalStarter.linkQuestionMark}
                                    rel="noreferrer"
                                    target="_blank"
                                  >
                                    Learn more.
                                  </a>
                                )}
                              </Tooltip>
                            )}
                          </td>
                        )}
                      {content.noncommercial.personalStarterPlus && (
                        <td
                          colSpan={content.noncommercial.colSpan && content.noncommercial.colSpan}
                          rowSpan={content.noncommercial.rowSpan && content.noncommercial.rowSpan}
                          className={cx(content.noncommercial.className)}
                        >
                          {content.noncommercial.personalStarterPlus.text === 'No' && (
                            <span className={cx('No')}>
                              <FontAwesomeIcon icon={faXmark} />
                            </span>
                          )}
                          {content.noncommercial.personalStarterPlus.text === 'Yes' && (
                            <span className={cx('Yes')}>
                              <FontAwesomeIcon icon={faCheck} />
                            </span>
                          )}
                          {(content.noncommercial.personalStarterPlus.text !== 'Yes'
                            && content.noncommercial.personalStarterPlus.text !== 'No')
                            && content.noncommercial.personalStarterPlus.link
                            && (
                              <Link to={content.noncommercial.personalStarterPlus.link}>
                                {content.noncommercial.personalStarterPlus.text}
                              </Link>
                            )}
                          {(content.noncommercial.personalStarterPlus.text !== 'Yes'
                            && content.noncommercial.personalStarterPlus.text !== 'No')
                            && !content.noncommercial.personalStarterPlus.link
                            && content.noncommercial.personalStarterPlus.text}
                          {content.noncommercial.personalStarterPlus.withQuestionMark && (
                            tooltip[activePlanTab] ?? tooltip.noncommercial
                          )}
                          {content.noncommercial.personalStarterPlus.textQuestionMark && (
                            <Tooltip
                              className={cx('question__help')}
                              isBigScreen={width >= 2800}
                            >
                              {content.noncommercial.personalStarterPlus.textQuestionMark}
                              {' '}
                              <a
                                href={content.noncommercial.personalStarterPlus.linkQuestionMark}
                                rel="noreferrer"
                                target="_blank"
                              >
                                Learn more.
                              </a>
                            </Tooltip>
                          )}
                        </td>
                      )}
                    </>
                  )
                )
            }
          </tr>
        ))
      }
      <tr className={cx('footer-btn')}>
        <td colSpan={activePlanTab === 'noncommercial' ? '4' : '6'} className={cx('title')}>
          <a
            className={cx('cta-buttons--contact-us-to-form')}
            href="#contactus-form"
            onClick={scrollToForm}
          >
            Contact Us
          </a>
        </td>
      </tr>
      {activePlanTab === 'commercial'
          && (
            <tr className={cx('footer-terms')}>
              <td colSpan="6">
                * Full Archive - from 1 Jan 2018 onward
              </td>
            </tr>
          )}
    </tbody>
  );
};

PricingPlansTableBody.propTypes = {
  activePlanTab: PropTypes.string.isRequired,
  tableContent: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ common, promobar }) => ({
  width: common.width,
  promobarHeight: promobar.height,
});

export default connect(mapStateToProps)(withComponentName(PricingPlansTableBody));
